// extracted by mini-css-extract-plugin
module.exports = {"container":"Accordion__container","accordionItem":"Accordion__accordionItem","title":"Accordion__title","active":"Accordion__active","content":"Accordion__content"};